function resizeImageUrl(imageUrl) {
  try {
    const delimiter = "?alt=";
    if (!imageUrl.includes(delimiter)) {
      throw new Error("Delimiter not found");
    }

    const [base, query] = imageUrl.split(delimiter);

    const lastSlashIndex = base.lastIndexOf('/');
    if (lastSlashIndex === -1) throw new Error("Invalid URL structure");

    const filename = base.substring(lastSlashIndex + 1);
    const pathBeforeFile = base.substring(0, lastSlashIndex + 1);

    const dotIndex = filename.lastIndexOf('.');
    const resizedFilename = dotIndex !== -1
      ? filename.substring(0, dotIndex) + "_300x300" + filename.substring(dotIndex)
      : filename + "_300x300";

    return pathBeforeFile + resizedFilename + delimiter + query;
  } catch (error) {
    console.warn("smalerImage error:", error.message);
    return imageUrl;
  }
}

const getters = {
  getResizeImageForMobileDevices: (getters, rootGetters) => (imageUrl) => {
    if (rootGetters.isMobile) {
      return resizeImageUrl(imageUrl);
    }
    return imageUrl;
  },
  getResizeImage: () => (imageUrl) => {
    return resizeImageUrl(imageUrl);
  }
};


export default {
   getters,
};
